const defaults = {
  i18n: {
    userLanguages: [
      { code: 'en', name: 'English US' },
      { code: 'ar', name: 'عربي' },
    ],
    defaultLng: undefined, // Language to use (overrides language detection).
    fallbackLng: 'en', // Language to use if translations in user language are not available.
  },
  homeLink: 'https://www.network.ae/',
  contactUsLink: 'mailto:KSAOnboarding@network.global',
  contactUsLinkServices:'mailto:KSAOnboarding@network.global',
  contactUsLinkWizardApplication:'mailto:KSAOnboarding@network.global',
  contactUsLinkContract: 'mailto:KSAOnboarding@network.global',
  contactUsLinkPayment: 'mailto:KSAOnboarding@network.global',
  contactUsLinkScreeningError: 'mailto:KSAOnboarding@network.global',
  contactUsLinkScreeningDecline: 'mailto:KSAOnboarding@network.global',
  contactUsLinkError: 'mailto:KSAOnboarding@network.global',
  contactUsLinkIndustry:'mailto:KSAOnboarding@network.global',
  contactUsLinkBranch:'mailto:KSAOnboarding@network.global',
  contactUsLinkSubmit:'mailto:KSAOnboarding@network.global',
  contactUsLinkSalesforceError:'mailto:KSAOnboarding@network.global',
  contactUsLinkSalesforceTechnicalError:'mailto:KSAOnboarding@network.global',
  contactUsLinkSoftDecline:'mailto:KSAOnboarding@network.global',
  contactUsLinkHardDecline:'mailto:KSAOnboarding@network.global',
  documentFileInput: {
    maxSizeB: 10 * 1024 * 1024,
    allowedFileTypes: ['.jpeg', '.jpg', '.png', '.pdf', '.doc', '.docx', '.gif', '.rtf'],
    maxCount: 50,
  },
  mapDefaultCountry: 'Saudi Arabia',
  defaultCountrySalesforce: 'United Arab Emirates', // TODO: country data refactoring
  mapDefaultCenter: { lat: 24.099502, lng: 45.063877 },
  mapApplicationListArea: {
    firstLatitude: 32.584088,
    firstLongitude: 32.640552,
    secondLatitude: 16.386956,
    secondLongitude: 56.891921,
  },
  tenantId: 'ni',
  realm: 'self-onboarding',

  agent: {
    leads: {
      enabled: false,
    },
  },

  sales: {
    enabled: true,
  },
};

export default defaults;
